import { Component, OnInit, ChangeDetectorRef, NgZone } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { AngularFireAuth } from '@angular/fire/auth';
import { ReservationPopupComponent } from 'src/app/reservation-popup/reservation-popup.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { AngularFireFunctions } from '@angular/fire/functions';

@Component({
  selector: 'app-reservations',
  templateUrl: './reservations.component.html',
  styleUrls: ['./reservations.component.scss']
})
export class ReservationsComponent implements OnInit {

  reservations: any[];
  loggedInUser: any;
  constructor(
    private firestore: AngularFirestore,
    private auth: AngularFireAuth,
    private dialog: MatDialog,
    private _snackBar: MatSnackBar,
    private fsFuncs: AngularFireFunctions,
    public zone: NgZone,
    private changeDetectorRef: ChangeDetectorRef,
  ) {
    auth.onAuthStateChanged(async (userInfo) => {
      this.loggedInUser = userInfo;
      this.getUserReservations();
    })
  }

  ngOnInit(): void {
  }
  openReservationsDialog() {
    this.dialog.open(ReservationPopupComponent, {
      width: '90%',
      data: {
        reservations: {
          msg: []
        }
      }
    }).afterClosed().subscribe(data => {
      if (true) {
        this.openSnackBar("Rezervacija uspešna", "OK", true)
        this.getUserReservations();
      }
    })
  }
  async getUserReservations() {
    this.firestore.collection(`users/${this.loggedInUser.uid}/reservations`)
      .get()
      .subscribe((data) => {
        this.reservations = data.docs.map((res) => {
          var r = res.data();
          r.id = res.id;
          r.date = new Date(r.dateTimestamp)
          r.createdTimestamp = new Date(r.createdTimestamp);
          const startingHour = r.from.split(":")[0]
          const startingMinute = r.from.split(":")[1]
          let d: Date = r.date;
          d.setHours(startingHour, startingMinute)
          let reservationStartingDateObj = d;
          r.started = new Date().getTime() > reservationStartingDateObj.getTime();
          return r;
        }).sort((a, b) => { return b.dateTimestamp - a.dateTimestamp })
        console.log(this.reservations)
      })
  }
  deleteReservation(reservation) {
    console.log(reservation)
    reservation.loading = true;
    this.fsFuncs.httpsCallable('deleteReservation')({
      reservationID: reservation.id
    }).subscribe((data) => {
      this.zone.run(() => {
        console.log(data);
        if (data.status === 200) {
          this.getUserReservations();
          this.openSnackBar("Rezervacija obrisana", "Ok")
        } else {
          this.openSnackBar("Neuspešno brisanje", "Ok")
        }
        reservation.loading = false;
        this.changeDetectorRef.markForCheck();
      })
    }, err => {
      reservation.loading = false;
      console.log(err)
      this.openSnackBar("Neuspešno brisanje", "Ok")
    })
  }
  openSnackBar(message: string, action: string, top?: boolean) {
    this._snackBar.open(message, action, {
      duration: 2000,
      verticalPosition: (top) ? 'top' : 'bottom'
    });
  }

}
